import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Leads (/leads). Anchors live in LeadsPage.tsx. */
export function getLeadsTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Your leads',
        description:
          'Every inquiry from your website lands here. Track where each person is in your ' +
          'pipeline and open them to log your follow-ups.',
      },
    },
    {
      element: at('leads-tabs'),
      popover: {
        title: 'Filter by status',
        description:
          'Show only leads at one stage, from New through Closed or Lost. Anything our spam check ' +
          'catches goes under “Spam” instead of your inbox. Nothing is deleted, and spam is left ' +
          'out of “All”.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('leads-search'),
      popover: {
        title: 'Find a lead',
        description: 'Type a name or email address to find someone quickly.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('leads-export'),
      popover: {
        title: 'Export to a spreadsheet',
        description: '“Export CSV” downloads the leads on the current page (up to 50 at a time).',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('leads-status'),
      popover: {
        title: 'Change a status',
        description:
          'Click a lead’s status to move them along your pipeline, right from the list.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: at('leads-view'),
      popover: {
        title: 'See the full picture',
        description:
          'Click “View Details” to see their contact info and message, the homes they’ve browsed, ' +
          'and a timeline of activity. You can also log a note, call, email or showing there.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: at('leads-table'),
      popover: {
        title: 'Your lead list',
        description:
          'Each lead shows their name, contact details, where they came from, their status and ' +
          'when they reached out.',
        side: 'top',
        align: 'center',
      },
    },
  ];
}
